import React, { useEffect, useState } from "react";
import axios from "axios";

console.log("API URL:", process.env.REACT_APP_NFLNEWS_API);


const Sidebar = () => {
    const [news, setNews] = useState([]);
    //const response = await axios.get("http://localhost:5001/api/nfl"); // Use axios

    useEffect(() => {
        async function fetchNFLNews() {
            try {

                const apiUrl = process.env.REACT_APP_NFLNEWS_API; // Get API URL from env
                //console.log("Fetching NFL news..."); // ✅ Debug log
                //const response = await axios.get("http://localhost:5001/api/nfl");
                //const response = await axios.get("http://localhost:8080/api/nfl");

                /* const response = await axios.get("http://localhost:8080/api/nfl", { timeout: 10000 }); */ // 5-second timeout
                const response = await axios.get(apiUrl , { timeout: 10000 }); // 5-second timeout
               

                //console.log("API Response:", response.data); // ✅ Log full response
                //setNews(response.data); // ✅ Store news in state
                setNews(response.data.slice(0, 5));  // ✅ Limit to 5 items

            } catch (error) {
                console.error("Error fetching news:", error);
                setNews([{ title: "Failed to load news", link: "#" }]); // Error handling
            }
        }

        fetchNFLNews();
    }, []);

    return (

        <aside className="right">
            <div className="panel">
                <h3>Latest News</h3>
                {news.length === 0 ? (
                    <p>Loading news...</p>
                ) : (
                <ul style={{ width: "100%", padding: 0, margin: 0 }}>
                {news.map((item, index) => (
                    <li key={index} style={{ width: "100%", marginBottom: "10px" }}>
                        <a 
                            href={item.link} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{
                                color: "#1a0dab",
                                textDecoration: "underline",
                                fontSize: "14px",
                                display: "block", /* ✅ Ensures full-width clickable area */
                                padding: "8px 0", /* ✅ Adds space for readability */
                                transition: "all 0.2s ease-in-out", /* ✅ Smooth hover effect */
                            }}
                        >
                            {item.title}
                        </a>
                        {index < news.length - 1 && <hr style={{ border: "0.5px solid #ccc" }} />} {/* ✅ Adds a separator */}
                    </li>
                ))}
            </ul>
                )}
            </div>
            {/* <div className="panel">Teams</div> */}
        </aside>
    );
};

// ✅ Second Sidebar (Another News Feed, e.g., NFL News)
const Sidebar2 = () => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        async function fetchNFLNews2() {
            try {
                //const response = await axios.get("http://localhost:5001/api/nfl2"); // ✅ Change API endpoint
                const response = await axios.get("http://localhost:8080/api/nfl2"); // ✅ Change API endpoint
                setNews(response.data.slice(0, 5)); // ✅ Limit to 5 items
            } catch (error) {
                console.error("Error fetching NFL news:", error);
                setNews([{ title: "Failed to load NFL news2", link: "#" }]);
            }
        }

        fetchNFLNews2();
    }, []);

    return (
        <aside className="right">
            <div className="panel">
                <h3>NFL News</h3>
                {news.length === 0 ? (
                    <p>Loading news...</p>
                ) : (
                    <ul>
                        {news.map((item, index) => (
                            <li key={index}>
                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                    {item.title}
                                </a>
                                {index < news.length - 1 && <hr style={{ border: "0.5px solid #ccc" }} />}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </aside>
    );
};


//export { Sidebar, Sidebar2 }; // ✅ Export both components
export { Sidebar }; 

